import { affiliateRegex } from "../getChicorySchema";

export function createAffiliateLinkIfNeeded(str: string) {
  const match = str.match(affiliateRegex);

  if (match) {
    // match[1] is everything before {} , match[2] is the group in {}, match[3] is the group in [] and match[4] is the group in ()
    // match[5] is everything after ()

    // return everything before {} + group in [] linking to group in () + everything after ()
    return (
      <>
        {match[1]}
        <a className="text-theme-primary underline" href={match[4]}>
          {match[3]}
        </a>
        {match[5]}
      </>
    );
  } else {
    return str;
  }
}
